import * as THREE from 'three'
import React, { Ref, useEffect, useRef, useState } from 'react'
import { useModel } from '../../../models/ModelMage'
import { Group, Object3D } from 'three'
import GameElements from '../../../../e.elements/GameElements/GameElement/GameElement'

let shareableHandSlot: Object3D
export const getHandSlot = () => shareableHandSlot

export const Mage = ({
  nodesSrc, // injected by CharactersAnimations component
  rightArm,
  ...props
}: { nodesSrc?: Record<string, Object3D>; rightArm?: any } & JSX.IntrinsicElements['group']) => {
  const [clonedNodes, setClonedNodes] = useState<Record<string, Object3D>>()
  const group = useRef<THREE.Group>()
  const { nodes } = useModel()

  useEffect(() => {
    if (nodes) {
      const clonedNodes = { Body: nodesSrc!.Body.clone() }
      clonedNodes.Body.add(nodes.character_mageBody)
      clonedNodes.Body.children.find(n => n.name === 'armRight')?.add(nodes.character_mageArmRight)
      clonedNodes.Body.children.find(n => n.name === 'armLeft')?.add(nodes.character_mageArnLeft)
      clonedNodes.Body.children.find(n => n.name === 'Head')?.add(nodes.character_mageHair)
      clonedNodes.Body.children.find(n => n.name === 'Head')?.add(nodes.character_mageHat)
      clonedNodes.Body.children.find(n => n.name === 'Head')?.add(nodes.character_mageHead)

      setClonedNodes(clonedNodes)
    }
  }, [nodes])

  const equipHand = (obj: Object3D) => {
    clonedNodes?.Body.traverse(n => {
      if (n.name === 'handSlotRight') {
        n.add(obj)
      }
    })
  }

  return (
    <group ref={group as Ref<Group>} {...props} dispose={null} name="Mage">
      {clonedNodes && <primitive object={clonedNodes.Body} />}
      {clonedNodes && rightArm && (
        <GameElements onStart={equipHand}>
          {rightArm}
        </GameElements>
      )}
    </group>
  )
}
